export default {"src":"/_next/static/image/public/images/ic_express_new.cb4b7e713e2808afd0b0dbc6b473b884.svg","height":14,"width":46};